/**
 * Какие строки «Товаров» участвуют в запросе сравнения производств — правило МСК Газобетона.
 *
 * Базовый путь (см. BackendProductions) считает список товаров невалидным целиком,
 * если хотя бы у одной строки нет наименования, и обнуляет `comparisons`. Нажатие
 * «Добавить товар» создаёт именно такую строку: она пустая до тех пор, пока менеджер
 * не выберет номенклатуру. В результате таблица аналогов пропадает («Нет данных»)
 * при уже посчитанном заказе, хотя ни один выбранный товар не изменился.
 *
 * Внутри МСК Газобетона незаполненная строка считается ещё не позицией заказа и просто
 * не участвует в расчёте — так же, как её уже игнорирует признак области
 * (см. isFilledProductRow в src/utils/mskGazobetonScope.js). Именно поэтому область
 * не выключается от появления пустой строки, и гейт здесь срабатывает.
 *
 * Вне области список отдаётся как есть: и состав строк, и обнуление сравнения
 * остаются в точности базовыми.
 */

/** Строка «Товаров» с выбранной номенклатурой. */
export const isFilledComparisonRow = (product) => Boolean(
  product && String(product.name || "").trim()
);

/**
 * Строки, которые уходят в расчёт сравнения производств.
 *
 * @param {object}  params
 * @param {Array}   params.products            — строки «Товаров» как есть
 * @param {boolean} params.isMskGazobetonScope — признак области МСК → Газобетон
 * @returns {Array} тот же массив вне области; без пустых строк — внутри
 */
export const getComparisonRequestRows = ({ products, isMskGazobetonScope } = {}) => {
  if (!Array.isArray(products)) {
    return products;
  }
  if (!isMskGazobetonScope) {
    return products;
  }
  return products.filter(isFilledComparisonRow);
};

export default getComparisonRequestRows;
